import React from "react";
import { Plural } from "@lingui/react/macro";

interface CruiseDepartureArrivalDatesProps {
  days: number | undefined;
  withSeparator?: boolean;
}

const CruiseDuration: React.FC<
  React.PropsWithChildren<CruiseDepartureArrivalDatesProps>
> = ({ days, withSeparator = false }) => {
  return (
    <React.Fragment>
      {withSeparator && <span aria-hidden>&nbsp;• </span>}
      <time dateTime={`P${days}D`}>
        <Plural value={days || 0} one="# DAY" other="# DAYS" />
      </time>
    </React.Fragment>
  );
};

export default CruiseDuration;
